/**
 * Préfixe le « Style personnalisé » d'un bloc de formulaire par le sélecteur du bloc.
 *
 * Remplace `sass.compileString(selector + "{" + css + "}")` : Sass ne servait qu'à ce préfixage et
 * embarquait environ 3 Mo de compilateur dans le navigateur. Le résultat est identique à celui de Sass
 * pour des déclarations et des règles imbriquées sur un niveau, soit toutes les valeurs en base au
 * 2026-09-14 (54 valeurs distinctes, 32 354 usages). Au-delà (@media, plusieurs niveaux, accolades
 * déséquilibrées), le CSS est confié tel quel à l'imbrication native du navigateur.
 * Ne lève jamais d'erreur : une saisie invalide ne casse plus le rendu du formulaire.
 *
 * Partagé admin ↔ web (dossier copié par copyFormPlugins.bash) : aucun import.
 */
export function scopeCustomCss(selector, css) {
    const source = String(css || "").replace(/\/\*[\s\S]*?\*\//g, "")
    let declarations = ""
    let rules = ""
    let buffer = ""
    let nestedSelector = ""
    let depth = 0
    let quote = null

    for (const char of source) {
        if (quote) {
            buffer += char
            if (char === quote) quote = null
            continue
        }
        if (char === '"' || char === "'") {
            quote = char
            buffer += char
            continue
        }
        if (char === "{") {
            // Imbrication sur plusieurs niveaux : laissée au navigateur
            if (depth++ > 0) return nativeNesting(selector, css)
            nestedSelector = buffer.trim()
            buffer = ""
            continue
        }
        if (char === "}") {
            if (--depth < 0 || !nestedSelector || nestedSelector.startsWith("@")) return nativeNesting(selector, css)
            rules += splitSelectors(nestedSelector)
                .map(part => part.startsWith("&") ? selector + part.slice(1) : selector + " " + part)
                .join(",") + "{" + buffer + "}"
            buffer = ""
            nestedSelector = ""
            continue
        }
        if (char === ";" && depth === 0) {
            declarations += buffer + ";"
            buffer = ""
            continue
        }
        buffer += char
    }

    if (depth !== 0 || quote) return nativeNesting(selector, css)
    declarations += buffer
    return (declarations.trim() ? selector + "{" + declarations + "}" : "") + rules
}

// Découpe « a, b:is(c, d) » sur les virgules de premier niveau uniquement
function splitSelectors(selectors) {
    const parts = []
    let current = ""
    let depth = 0
    let quote = null

    for (const char of selectors) {
        if (quote) {
            if (char === quote) quote = null
        } else if (char === '"' || char === "'") {
            quote = char
        } else if (char === "(" || char === "[") {
            depth++
        } else if (char === ")" || char === "]") {
            depth--
        } else if (char === "," && depth === 0) {
            parts.push(current.trim())
            current = ""
            continue
        }
        current += char
    }
    parts.push(current.trim())
    return parts
}

function nativeNesting(selector, css) {
    return selector + "{" + css + "}"
}
